import React from 'react';
import styles from './SimilarLink.css';
import { ISimilarLink } from '../../types/similar-link';

interface ISimilarLinkProps extends ISimilarLink {
  onClick(e: React.MouseEvent<HTMLAnchorElement>): void;
}

export function SimilarLink(props: ISimilarLinkProps) {
  return (
    <div className={styles['cont']}>
      <a href={props.url} rel="nofollow noopener" target="_blank" onClick={props.onClick}>
        {props.text}
      </a>
    </div>
  );
}
